import { gql } from '@apollo/client';

// Teacher view: their class code + roster.
export const GET_MY_CLASS = gql`
  query GetMyClass {
    myClass {
      code
      studentLimit
      students {
        name
        joinedAt
      }
    }
  }
`;

// Public lookup used by the join page to render the teacher's name + capacity.
export const GET_CLASS_BY_CODE = gql`
  query GetClassByCode($code: String!) {
    classByCode(code: $code) {
      teacherName
      classCode
      isFull
      studentCount
      studentLimit
    }
  }
`;

// Student view of their own session.
export const GET_STUDENT_SESSION = gql`
  query GetStudentSession {
    studentSession {
      studentName
      teacherName
    }
  }
`;

export const ENSURE_CLASS_CODE = gql`
  mutation EnsureClassCode {
    ensureClassCode {
      code
      studentLimit
      students {
        name
        joinedAt
      }
    }
  }
`;

export const REGENERATE_CLASS_CODE = gql`
  mutation RegenerateClassCode {
    regenerateClassCode {
      code
      studentLimit
      students {
        name
        joinedAt
      }
    }
  }
`;

export const REMOVE_CLASS_STUDENT = gql`
  mutation RemoveClassStudent($name: String!) {
    removeClassStudent(name: $name) {
      code
      studentLimit
      students {
        name
        joinedAt
      }
    }
  }
`;
